import { PortalUnitsFilterButton } from '@apps-common/apps/portal/pages/units/components/portal/PortalUnitsFilterButton'
import { NavbarCompanyLogo } from '@apps-common/components/common/logos'
import { PageTitle } from '@apps-common/components/common/portal-title'
import { ButtonRoundSm } from '@apps-common/components/elements/button'
import { Header, VertSpacerLg, VertSpacerMd, VertSpacerSm } from '@apps-common/components/layout'
import { Breadcrumbs, Navbar } from '@apps-common/components/navigation'
import { commonIcons } from '@apps-common/config/icons'
import { snakeToSentence } from '@apps-common/helpers/snakeCaseToSentence'
import { IAppNavigationOptions } from '@apps-common/hooks/useNavigation'
import { usePortalUnitsFilterStore } from '@apps-common/stores'
import { ROUTE_UNIT_ACTIVATIONS, ROUTE_UNITS } from '@apps-radionet-portal/config/private-routes'

interface IProps {
  icons?: any[]
  rightComponent?: any
  leftComponent?: any
  loading: boolean
  navigateForward: (opts: IAppNavigationOptions) => void
  searchCount: number
}

export const PortalUnitsHeader: React.FC<IProps> = ({ icons, rightComponent, leftComponent, loading, navigateForward, searchCount }) => {
  const portalFilterState = usePortalUnitsFilterStore()

  return (
    <Header classes='!max-w-[1650px]'>
      <Navbar transparent startComponents={<NavbarCompanyLogo />} icons={icons} />
      <Breadcrumbs route={ROUTE_UNITS} />
      <div className='flex items-start justify-between'>
        <PageTitle classes='flex items-start gap-[10px] capitalize'>
          Devices <span className='hidden md:inline-block text-[0.6em] jost-medium'>({snakeToSentence(portalFilterState.status)})</span>
        </PageTitle>
        <div className='flex items-center gap-[8px]'>
          <ButtonRoundSm
            type='button'
            size='lg'
            className='action-success'
            tooltip={{ id: `devices-activations-tooltip`, message: 'Activations' }}
            callback={() =>
              navigateForward({
                routeUrl: ROUTE_UNIT_ACTIVATIONS.buildPath(),
                route: ROUTE_UNIT_ACTIVATIONS
              })
            }
          >
            <commonIcons.srActivations />
          </ButtonRoundSm>
          <PortalUnitsFilterButton />
        </div>
      </div>
      <VertSpacerMd className='hidden md:block' />
      <VertSpacerLg className='block md:hidden' />
      <div className='flex items-center justify-between gap-[5px] sm:px-[5px] sm:pt-0'>
        {leftComponent}
        {rightComponent}
      </div>
      {(rightComponent || leftComponent) && <VertSpacerSm />}
    </Header>
  )
}
